import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
    return (
        <div className="full-terms-container">
            <div className="full-terms-content">
                <h1>Payment Terms and GDPR</h1>      
                <section>     
                    <p>
                        The GDPR rules that apply throughout Europe ensure that privacy is the 
                        same in all markets within the EU and that consumers' privacy rights can 
                        be legally handled everywhere.               
                    </p>
                </section>

                <section>
                    <p>How payments are affected by the GDPR / GDPR for e-commerce: </p>
                    <ul>
                        <li>
                            All companies have the right to store data in order to be able to 
                            collect payments. This data must be processed lawfully and in 
                            accordance with the GDPR. When it comes to payments, this usually 
                            happens during the execution of a contract. This means that you do 
                            not need permission to the same extent to use and store payment 
                            information. As long as the information is used for the life of the 
                            product or service, the revocable permission applies. This is 
                            important for subscriptions, guarantees and refunds via credit card. 
                            However, it is temporarily not permitted to use this personal data for
                            other purposes.  
                        </li>
                    </ul>
                </section>

                <section>
                    <p>There are number of rights under the GDPR, including: </p>
                    <ul className='dashed'>
                        <li>
                            <b>Consumer rights, what do you need to know? </b>
                        </li>
                    </ul>
                    <p>These can be:</p>       
                    <ul>
                        <li>The data subject: The consumer</li>
                        <li>The data controller: The company</li>
                        <li>
                            The data processor: A third party that processes personal data 
                            on behalf of the data controller
                        </li>               
                    </ul>
                </section>

                <section>
                    <ul className='dashed'>
                        <li>
                            <b>Customer rights: </b>
                        </li>
                    </ul>
                    <p>
                        These apply to customer rights, especially when it comes to payment 
                        information.
                    </p> 

                    <ul className='dashed'>
                        <li>
                            <b>The data subject has the right to their own data: </b>
                        </li>
                    </ul>
                    <p>
                        The data subject can request access to all data a company has about 
                        them, and at any time. This also applies to payment information.
                    </p>
                    
                    <ul className='dashed'>
                        <li>
                            <b>The right to deletion, what data can or cannot be deleted: </b>
                        </li>
                    </ul>
                    <p>
                        If the company has entered into an agreement with the customer and 
                        the data is necessary to continue the service, the necessary 
                        information must not be erased. For example, a customer has a 
                        subscription, the company must store the information in order to 
                        continue invoicing.
                    </p>

                    <ul className='dashed'>
                        <li>
                            <b>State the legal basis for the processing, for example: </b>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            Performance of a contract (for example processing payments), 
                            compliance with legal obligations (for example anti-money 
                            laundering laws) and legitimate interests (for example fraud 
                            prevention). 
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    );
}

export default PrivacyPolicy; 